import PersonalDetailsQuestion from '@/views/shared/advanced-finance/PersonalDetailsQuestion.vue';

export default [
  {
    path: '',
    redirect: { path: 'personal-details' },
  },
  {
    path: 'personal-details',
    component: PersonalDetailsQuestion,
    meta: {
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'address-information',
    },
  },
  {
    path: 'address-information',
    meta: {
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'previous-address-information',
    },
  },
  {
    path: 'previous-address-information',
    meta: {
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'employment-type',
    },
  },
  {
    path: 'employment-type',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
    },
  },
  {
    path: 'current-employer-information-form',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'previous-employment-details',
    },
  },
  {
    path: 'retirement-details',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
    },
  },
  {
    path: 'self-employed-details',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'current-employer-information-form',
    },
  },
  {
    path: 'previous-employment-details',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'previous-employment-information-form',
    },
  },
  {
    path: 'previous-employment-information-form',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'income-details',
    },
  },
  {
    path: 'income-details',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'other-income',
    },
  },
  {
    path: 'other-income',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'other-income-details',
    },
  },
  {
    path: 'other-income-details',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'rent-mortgage-details',
    },
  },
  {
    path: 'rent-mortgage-details',
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 2,
        to: 3,
      },
      numberOfSteps: 4,
      hasNext: true,
      nextRoutePath: 'application-submitted',
    },
  },
  {
    path: 'application-submitted',
    meta: {},
  },
];
